<emperor-add-item
  [text]="text"
  [icon]="icon || ''"
  [helpText]="helpText"
  [canAddMore]="canAddMore"
  [loadingSpinner]="(buttonDisabled$ | async)!"
  (addItem)="addClicked()"
>
</emperor-add-item>
